module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "label-width": _vm.queryFormLabelWidth,
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "shop_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "remote-method": _vm.remoteShopMethod,
      "placeholder": "请输入店铺"
    },
    model: {
      value: (_vm.queryForm.shop_id),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "shop_id", $$v)
      },
      expression: "queryForm.shop_id"
    }
  }, _vm._l((_vm.shopList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户评分",
      "prop": "qualityCode"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.queryForm.qualityCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "qualityCode", $$v)
      },
      expression: "queryForm.qualityCode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "1",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "2",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "4",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "5",
      "value": "5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "日期",
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.queryForm.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "dateRange", $$v)
      },
      expression: "queryForm.dateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配送评价:",
      "prop": "deliveryScore"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.deliveryScore),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "deliveryScore", $$v)
      },
      expression: "queryForm.deliveryScore"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "满意",
      "value": "100"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "不满意",
      "value": "85"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价关键字",
      "prop": "comment"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.queryForm.comment),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "comment", $$v)
      },
      expression: "queryForm.comment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.queryForm.pageNo = 1;
        _vm.fetchData()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('queryForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', {
    staticClass: "pb20"
  }, [_c('export-excel', {
    attrs: {
      "params": _vm.exportParams,
      "action": _vm.$apiUrl.estimateList,
      "target": 'oc',
      "field": _vm.field,
      "filename": _vm.fileName,
      "fieldname": _vm.fieldName
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "城市名称",
      "show-overflow-tooltip": true,
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "schoolName",
      "label": "学校名称",
      "show-overflow-tooltip": true,
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "supplierCode",
      "label": "店铺代码",
      "show-overflow-tooltip": true,
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "supplierShortName",
      "label": "店铺名称",
      "show-overflow-tooltip": true,
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qualityCode",
      "label": "用户评分",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deliveryScore",
      "label": "配送评价",
      "show-overflow-tooltip": true,
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.deliveryScore && scope.row.deliveryScore != 0) ? _c('span', [_vm._v(_vm._s(scope.row.deliveryScore == 85 ? '不满意' : '满意'))]) : _c('span', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "comment",
      "label": "评价内容",
      "show-overflow-tooltip": true,
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "评价时间",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "fixed": "right",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.operateEstimate(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.hided == 1 ? '隐藏' : '未隐藏'))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewDetail(scope.row)
            }
          }
        }, [_vm._v("查看详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNo,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "评价详情",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', [_vm._v("订单号："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.detail.orderId))])]), _vm._v(" "), _c('p', [_vm._v("评价时间："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.detail.date))])]), _vm._v(" "), _c('p', [_vm._v("用户昵称："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.detail.userName || '匿名'))])]), _vm._v(" "), _c('p', [_vm._v("用户评分："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.detail.qualityCode) + "分")])]), _vm._v(" "), _c('p', [_vm._v("口味："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.detail.tasteScore))]), _vm._v("星  包装："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.detail.packScore))]), _vm._v("星   "), (_vm.detail.deliveryScore) ? _c('span', {
    staticClass: "c6"
  }, [_vm._v("配送：" + _vm._s(_vm.detail.deliveryScore))]) : _vm._e()]), _vm._v(" "), _c('p', _vm._l((_vm.detail.deliveryEstimateList), function(item, index) {
    return _c('span', {
      key: index,
      staticStyle: {
        "border": "1px solid #ddd",
        "border-radius": "12px",
        "font-size": "12px",
        "padding": "5px",
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), (_vm.detail.deliveryComment) ? _c('p', [_vm._v("配送评价内容："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.detail.deliveryComment))])]) : _vm._e(), _vm._v(" "), (_vm.detail.comment) ? _c('p', [_vm._v("商家/菜品评价内容："), _c('span', {
    staticClass: "c6"
  }, [_vm._v(_vm._s(_vm.detail.comment))])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n            商品评价：\n            "), _vm._l((_vm.detail.goodsMarkList), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "c6"
    }, [_vm._v(_vm._s(item.goodsName) + "," + _vm._s(item.goodsScore) + "分")])
  }), _vm._v(";\n        ")], 2), _vm._v(" "), _c('p', [_vm._v("\n            评价图片：\n            "), _vm._l((_vm.detail.urls), function(item) {
    return _c('img', {
      staticStyle: {
        "margin-right": "10px",
        "vertical-align": "top",
        "cursor": "pointer"
      },
      attrs: {
        "src": item,
        "width": "60",
        "height": "60",
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.preview(item)
        }
      }
    })
  })], 2)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "预览",
      "visible": _vm.innerVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.innerVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.previewUrl,
      "width": "100%",
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e0294a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/aftersale/estimate/list.vue
// module id = 881
// module chunks = 0